import { createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex-colum h-100" }
const _hoisted_2 = { class: "d-flex justify-content-between bd-highlight mb-3" }
const _hoisted_3 = {
  class: "align-self-center mb-3",
  style: {"height":"30px"}
}
const _hoisted_4 = {
  class: "input-group align-self-center ms-auto p-2 bd-highlight",
  style: {"width":"40%"}
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("option", {
  selected: "",
  value: ""
}, "选择试卷类型", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("option", { value: "system" }, "系统", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("option", { value: "meal" }, "项目", -1)
const _hoisted_8 = [
  _hoisted_5,
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("option", {
  selected: "",
  value: ""
}, "选择题类型", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("option", { value: "trueFalse" }, "判断题", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("option", { value: "radio" }, "单选题", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("option", { value: "checkbox" }, "多选题", -1)
const _hoisted_13 = [
  _hoisted_9,
  _hoisted_10,
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = { class: "table table-bordered table-striped table-sm member-list" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"50px"} }, "序号"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"100px"} }, "题目类型"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"100px"} }, "考题类型"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"300px"} }, "标题"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"300px"} }, "答题选项"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"100px"} }, "答案"),
    /*#__PURE__*/_createElementVNode("th", null, "状态"),
    /*#__PURE__*/_createElementVNode("th", null, "排序"),
    /*#__PURE__*/_createElementVNode("th", null, "添加时间"),
    /*#__PURE__*/_createElementVNode("th", null, "操作")
  ])
], -1)
const _hoisted_16 = { class: "flex-colum" }
const _hoisted_17 = { class: "flex-colum" }
const _hoisted_18 = {
  class: "mb-1 form-check form-switch",
  style: {"padding-top":"5px"}
}
const _hoisted_19 = ["checked", "onChange"]
const _hoisted_20 = { class: "flex-row flex-align-center" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_AddExamQuestionDialog = _resolveComponent("AddExamQuestionDialog")!
  const _component_LoadingDialog = _resolveComponent("LoadingDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.openAddQuestionDialog && $setup.openAddQuestionDialog(...args)))
          }, "添加")
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createTextVNode("   "),
          _withDirectives(_createElementVNode("select", {
            class: "form-select",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.examType) = $event)),
            onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.searchQuestionInner && $setup.searchQuestionInner(...args)))
          }, _hoisted_8, 544), [
            [_vModelSelect, _ctx.examType]
          ]),
          _createTextVNode("   "),
          _withDirectives(_createElementVNode("select", {
            class: "form-select",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.questionType) = $event)),
            onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($setup.searchQuestionInner && $setup.searchQuestionInner(...args)))
          }, _hoisted_13, 544), [
            [_vModelSelect, _ctx.questionType]
          ]),
          _createTextVNode("   "),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "article-keywords",
            class: "form-control",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.keywords) = $event)),
            placeholder: "标题/选项"
          }, null, 512), [
            [_vModelText, _ctx.keywords]
          ]),
          _createElementVNode("button", {
            class: "btn btn-outline-secondary",
            type: "button",
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => ($setup.searchQuestionInner && $setup.searchQuestionInner(...args)))
          }, "搜索")
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("table", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.dataList, (value, idx) => {
              return (_openBlock(), _createElementBlock("tr", { key: idx }, [
                _createElementVNode("td", null, _toDisplayString(50 * ($setup.nowPage - 1) + idx + 1), 1),
                _createElementVNode("td", null, _toDisplayString(value.examType === 'system'?'系统':'项目'), 1),
                _createElementVNode("td", null, _toDisplayString($setup.getQuestionType(value.questionType)), 1),
                _createElementVNode("td", null, _toDisplayString(value.title), 1),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_16, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(value.optionList, (v, index) => {
                      return (_openBlock(), _createElementBlock("div", null, _toDisplayString(index+1) + "、 " + _toDisplayString(v.option), 1))
                    }), 256))
                  ])
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_17, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(value.answerList, (v, index) => {
                      return (_openBlock(), _createElementBlock("div", null, _toDisplayString($setup.getAnswer(v, value)), 1))
                    }), 256))
                  ])
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("input", {
                      class: "form-check-input",
                      checked: value.show,
                      onChange: ($event: any) => ($setup.updateQuestion(value)),
                      type: "checkbox",
                      role: "switch"
                    }, null, 40, _hoisted_19)
                  ])
                ]),
                _createElementVNode("td", null, _toDisplayString(value.sort), 1),
                _createElementVNode("td", null, _toDisplayString(value.createTime), 1),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("img", {
                      class: "button-icon",
                      src: "/assets/ic_edit.png",
                      onClick: ($event: any) => ($setup.openEditQuestionDialog(value))
                    }, null, 8, _hoisted_21),
                    _createElementVNode("img", {
                      class: "button-icon img-margin",
                      src: "/assets/ic_trash.png",
                      onClick: ($event: any) => ($setup.deleteQuestion(value.id, value.title))
                    }, null, 8, _hoisted_22)
                  ])
                ])
              ]))
            }), 128))
          ])
        ]),
        _createVNode(_component_Pagination, {
          page: $setup.nowPage,
          max: $setup.totalPage/50,
          onLoadPage: $setup.loadQuestionList
        }, null, 8, ["page", "max", "onLoadPage"])
      ])
    ]),
    _createVNode(_component_AddExamQuestionDialog, {
      ref: "addDialogRef",
      show: _ctx.showAddDialog,
      onConfirm: $setup.editExamQuestion,
      onConfirmAdd: $setup.editExamQuestionAdd,
      onConfirmNext: $setup.editExamQuestionNext,
      onCancel: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showAddDialog=false))
    }, null, 8, ["show", "onConfirm", "onConfirmAdd", "onConfirmNext"]),
    _createVNode(_component_LoadingDialog, { show: _ctx.showLoadingDialog }, null, 8, ["show"])
  ], 64))
}